function renderInstantor () {
  return '<div class="ui-form__row hidden">' +
    '<div class="ui-form__field">' +
    '<p style="margin: auto; text-align: center; max-width: 400px">' + fields_json.params.for_fields.instantor + '</p>' +
    '<div id="itor" style="padding: 20px;border: 1px solid #dddfe0;border-radius: 5px;">Waiting&hellip;</div>' +
    '<div class="has_declined_instantor_shower hidden"><a id="has_declined_instantor" style="cursor: pointer">' + fields_json.params.for_fields.instantor_skip[0] + '</a>' + fields_json.params.for_fields.instantor_skip[1] + '</div>\n' +
    '</div>' +
    '</div>'
}

export { renderInstantor }